// import './string.extensions'
export interface ITimeSpan {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds: number;
}

export class TimeSpan implements ITimeSpan {
  days: number;
  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;
  milliseconds: number = 0;

  constructor(timespan: ITimeSpan) {
    this.days = timespan.days;
    this.hours = timespan.hours;
    this.minutes = timespan.minutes;
    this.seconds = timespan.seconds;
    this.milliseconds = timespan.milliseconds;
  }

  format(): string {
    return this.getParts().filter(Boolean).join(', ');
  }

  getParts() : string[] {
    return [
      this.days ? `${this.days} days` : '',
      this.hours ? `${this.hours} hours` : '',
      this.minutes ? `${this.minutes} minutes` : '',
      this.seconds ? `${this.seconds} seconds` : '',
      this.milliseconds ? `${this.milliseconds} milliseconds` : ''
    ]
  }

  static create(timeSpan: string) {
    return timeSpan.toTimeSpan();
  }
}
